export const UserApi = {
  GetExternalUser: 'search',
  GetAllSSOUser: 'sso/all',
  GetAllInternalUsers: 'internal/all',
  GetShipTo: 'search/shipto',
  GetUsersByCust: 'account/all',
  GetRole: 'role',
  SaveRole: 'idmrole/save',
  ResetPassword: 'password/reset/email',
  ResendActivation: 'resend/activate/email',
  GetNuctracGroups: 'groups/all',
  GetassignedGroup: 'group',
  SaveGroup: 'group/save',
  GetStatistics: 'statistics',
  GetDevices: 'devices',
  GetUserNotLoggedIn: 'notloggedin',
  GetInvoiceUsers: 'invoice/users',
  GetHubFacilityData: 'digi/hubfacilityxref',
  GetDigiData: 'digi/hub',
  SaveMobileFacility: 'digi/facility/mobile',
  SearchAccountUrl: 'search/shipto',
  SaveHubFacilityData: 'digi/hubfacilityxref/save',
  GetAllLocations: 'locations',
  GetLocationUsers: 'location/all',
  saveAllAccountNumbersData: 'save/multiple',
  Getaaauserslist: 'aaa',
  Getusername: 'aaa',
  GetStaticDataUrl: 'data/static',
  GetAllModules: 'modules',
  SaveNuctracStandingOrder: 'otc/standingorder/save',
  SaveNuctracAccountLicenseDetail: 'customer/license/save',
  GetNuctracOrderHistory: 'otc/order/history',
  ManagealertDashbord: "nuctrac-utility/v1/api/alert?cacheBuster=1635415793638",

  //Nuctrac Accounts
  GetShipToAccountsUrl: "dms/all",
  DeleteShipToAccountUrl: "dms",
  SaveShipToAccountUrl: "dms",
  GetHL7AccountsUrl: 'custapigeemap/shiptoxref',
  SaveHL7AccountsUrl: 'save/custapigee',
  SaveSSOFlag: 'sso/customer',
  SaveReturnFlag: 'autoinvrtn/customer',
  GetReturnFlagAccount: 'autoinvrtn/customer/all',
  GetHistory: 'otc/order/history',
  //Account Settings
  GetCustomerData: 'customerdata',
  UserPharmacy: "pharmacy/preferences",
  AppMaintenance: "appmaintenance",
  SavePharmacyLocations: "pharmacy/preference/saveAll",
  GetNuctracAccountLicenseDetail: 'customer/license',
  GetNuctracStandingOrder: 'otc/standingorder',
  GetNuctracProducts: 'otc/products/all',

};

export const OrderApi = {

  SaveNuctracOrder: 'otc/save',
  ExecuteBillingJob: 'otc/monthlybilling',
  getRejectedNotificationDetails: '/order/reject-notification',
  acknowledgeRejectNotification:'/order/reject-notification/acknowledge',
  sendEmail340BEntityFormPDF:'/order/email/send'
}

export const ApiPrefix = {
  Auth: '/',
  Login: '',
  User: '',
  nutracConfig: '',
};

export const MiscApi = {
  Settings: '/settings',
  Log: '/log',
  RelayUrl: '/relayurl',
};

export const AuthApi = {
  Authenticate: 'authenticate',
  Password: {
    ResetEmail: 'password/forgot/email',
    Reset: 'password/reset',
    Update: 'password/change',
  },
  Token: {
    Verify: 'token/verify',
  },
  Recovery: {
    Answer: 'recovery/answer',
    Change: 'recovery/question/change',
    Questions: 'recovery/questions',
    UserDetails: 'recovery/userdetails',
  },
  Account: {
    UnlockEmail: 'unlock/email',
    Setup: 'setup/useraccount',
  },
};

export const OktaApi = {
  OktaSession: '/api/v1/sessions/me'
};

export const DocumentRepositoryApi = {
  moveInsideDocumentRepo: "/api/document/movedocument"
}
